import React from 'react'
import {
  IonSlides,
  IonSlide,
  IonSkeletonText
} from '@ionic/react'
import ProductSquaredCardSkeleton from '../../../components/skeletons/ProductSquaredCardSkeleton'
import './styles.scss'

const PodcastCategorySwipperSkeleton = () => {
  const slideOpts = {
    initialSlide: 0,
    slidesPerView: 'auto',
    preventClicks: true,
    speed: 400
  }

  return (
    <section className='podcast-category-swipper-skeleton'>
      <IonSkeletonText className='category-title' animated />
      <IonSlides options={slideOpts}>
        <IonSlide>
          <ProductSquaredCardSkeleton showTitle />
        </IonSlide>
        <IonSlide>
          <ProductSquaredCardSkeleton showTitle />
        </IonSlide>
        <IonSlide>
          <ProductSquaredCardSkeleton showTitle />
        </IonSlide>
        <IonSlide>
          <ProductSquaredCardSkeleton showTitle />
        </IonSlide>
        <IonSlide>
          <ProductSquaredCardSkeleton showTitle />
        </IonSlide>
        <IonSlide>
          <ProductSquaredCardSkeleton showTitle />
        </IonSlide>
      </IonSlides>
    </section>
  )
}

export default PodcastCategorySwipperSkeleton
